module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-180x180-7a1b972874873a6817dbf6438b8ee724.png";